import * as Yup from "yup";

export function initialValues(student) {
  return {
    status: student?.status || "",
  };
}

export function validationSchema() {
  return Yup.object().shape({
    status: Yup.number().required("El estado es obligatorio"),
  });
}
